import { Typography } from "../../../../../core/components/molecules/Typography";
import { Modal } from "../../../../../core/components/templates/Modal";
import { Button } from "../../../../../core/components/atoms/Button";
import { useDeleteScheduleHook } from "../../../hooks/Schedule/useDeleteScheduleHook";
import { useEffect, useState } from "react";
import { toast } from "../../../../../core/components/atoms/Toast";
import { usePlanConfigStore } from "../../../stores/planConfigStore";

const SCHEDULE_ADVANCE_STORAGE_KEY = "advance-schedule";

interface IConfirmDeleteModal {
    isOpen: boolean;
    onClose: () => void;
    scheduleId?: string;
}

const ConfirmDeleteModal: React.FC<IConfirmDeleteModal> = ({
    isOpen,
    onClose,
    scheduleId,
}) => {
    const { mutate, isError, isSuccess, isPending, error } = useDeleteScheduleHook();
    const [showSuccess, setShowSuccess] = useState(false);
    const resetPlanConfig = usePlanConfigStore((state) => state.resetPlanConfig);

    const handleDeleteSchedule = () => {
        if (scheduleId) {
            mutate(scheduleId, {
                onSuccess: () => {
                    resetPlanConfig();
                    if (typeof window !== "undefined") {
                        window.localStorage.removeItem(SCHEDULE_ADVANCE_STORAGE_KEY);
                    }
                }
            });
        }
    }

    useEffect(() => {
        if (isSuccess) {
            setShowSuccess(true);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            toast({
                variant: "error",
                title: "Erro ao deletar cronograma",
                message: error?.message || "Ocorreu um erro ao deletar o cronograma",
                position: "top-right",
                autoClose: 5000,
            });
            onClose();
        }
    }, [isError, error]);

    const handleCloseSuccess = () => {
        onClose();
        window.location.href = '/';
    };
    
    return (
      <Modal
        isOpen={isOpen}
        onClose={() => onClose()}
        position='center'
        className={'max-w-[550px]'}
        title='Excluir Cronograma'
        noPadding
      >
        {showSuccess ? (
          <div className='flex flex-col'>
            <div className='px-6 py-6 text-center'>
              <Typography weight='bold'>
                Cronograma excluído com sucesso.
              </Typography>
            </div>
            <div className='flex items-center justify-center px-6 py-4 shadow-level-2'>
              <Button variant='contained' full onClick={handleCloseSuccess}>
                Fechar
              </Button>
            </div>
          </div>
        ) : (
          <div className='flex flex-col'>
            <div className='px-6 py-6 text-center'>
              <Typography weight='bold'>
                Tem certeza que deseja excluir este cronograma?
              </Typography>
              <Typography className='mt-2'>
                Essa ação é permanente e apagará todo o seu progresso. O novo cronograma começará do zero e pode incluir conteúdos já estudados. Anote o que você já viu para marcar como concluído depois.
              </Typography>
            </div>
            <div className='flex items-center justify-between gap-lg px-6 py-4 shadow-level-2'>
              <Button variant='text' onClick={() => onClose()} full>
                Cancelar
              </Button>
              <Button
                variant='contained'
                onClick={() => handleDeleteSchedule()}
                loading={isPending}
                full
                className='bg-feedback-color-error-pure transition-colors duration-300 ease-in-out hover:bg-[#b84343]'
              >
                Excluir cronograma
              </Button>
            </div>
          </div>
        )}
      </Modal>
    );
};

export default ConfirmDeleteModal;
